import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import { getReceipts } from '../../api';
import './_styles.receipts.scss';

// Local (not UTC) YYYY-MM-DD, so an early-morning receipt doesn't display as
// the previous day.
const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0')
  ].join('-');
};

const Receipts = () => {
  const navigate = useNavigate();
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  useEffect(() => {
    setLoading(true);
    getReceipts(page)
      .then(({ data }) => {
        setReceipts(data.rows || []);
        setPages(data.pages || 1);
      })
      .catch((err) => console.error('Failed to load receipts', err))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className='receipts'>
      <div className='receipt-header'>
        <h3>Receipts</h3>
        <Button title='Create New' onClick={() => navigate('/receipts/new')} />
      </div>

      <div className='receipt-table'>
        <table>
          <thead>
            <tr>
              <th>Receipt #</th>
              <th>Date</th>
              <th>Supplier</th>
              <th>Site</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className='empty'>
                  Loading...
                </td>
              </tr>
            ) : receipts.length === 0 ? (
              <tr>
                <td colSpan={5} className='empty'>
                  No receipts yet.
                </td>
              </tr>
            ) : (
              receipts.map((receipt) => (
                <tr
                  key={receipt.id}
                  onClick={() => navigate(`/receipts/${receipt.id}`)}
                >
                  <td>{receipt.id}</td>
                  <td>{formatDate(receipt.date)}</td>
                  <td>{receipt.supplier || '-'}</td>
                  <td>{receipt.site || '-'}</td>
                  <td>{receipt.quantity ?? '-'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className='receipt-pagination'>
        <button
          disabled={page <= 1 || loading}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>
        <span>
          Page {page} of {pages}
        </span>
        <button
          disabled={page >= pages || loading}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Receipts;
